var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$slots.default && _vm.$slots.default[0])?_c('span',{staticClass:"Icon",class:_vm.$slots.default[0].text,style:({
        fontSize: _vm.icon_font_size,
    }),attrs:{"aria-hidden":"true"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }